import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Pagination from './components/Pagination/index.vue';

Vue.use(ElementUI);
Vue.component(Pagination.name, Pagination)
// import axios from 'axios'
// Vue.component(Pagination.name, Pagination)
// axios.default.baseURL = 'http:127.0.0.1:8000' // 配置请求根路径
// Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
